import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrapping <App> in <React.StrictMode> does a double render locally for components.
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
